// extracted by mini-css-extract-plugin
module.exports = {"icon":"BackButton_icon__11ONH","wrapper":"BackButton_wrapper__2t5fq"};